konnyScript(function($){
    
    var swiper = new Swiper("#sleep2505_swiper_slide1", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        scrollbar: {
            el:'#sleep2505_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el:'#sleep2505_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#sleep2505_swiper_slide1 .swiper-button-next',
            prevEl: '#sleep2505_swiper_slide1 .swiper-button-prev',
        },
    });

})